<template>
  <div>
    <HeaderGestion/>
    <SubHeaderGestion nombreGestion="Misceláneos"/>
    <FormMiscel/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormMiscel from '../components/FormMiscel.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormMiscel },
  name: 'GesMiscel'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
